import { render, staticRenderFns } from "./grainSubsidy.vue?vue&type=template&id=49abada1&scoped=true"
import script from "./grainSubsidy.vue?vue&type=script&lang=js"
export * from "./grainSubsidy.vue?vue&type=script&lang=js"
import style0 from "./grainSubsidy.vue?vue&type=style&index=0&id=49abada1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49abada1",
  null
  
)

export default component.exports